<template>
  <div v-if="!entry"></div>
  <article v-else class="table--scroll">
    <header v-if="!!(entry['title_' + locale] || entry.title)">
      <h1>{{ entry['title_' + locale] || entry.title }}</h1>
    </header>
    <MarkdownText :md="entry['content_' + locale] || entry.content" />
  </article>
</template>

<script>
import MarkdownText from '../shared/MarkdownText.vue';
import eventList from '../assets/eventList';
import { urlify } from '../util';
import { locale } from '../locale';

export default {
  name: 'EventArticle',
  data() {
    return {
      entry: null,
      locale,
    };
  },
  methods: {
    updateEntry(route) {
      const { title } = route.params;
      this.entry = eventList.find(entry => urlify(entry.title) === title);
    },
  },
  created() {
    this.updateEntry(this.$route);
  },
  watch: {
    $route(to, from) {
      this.updateEntry(to);
    },
  },
  components: {
    MarkdownText,
  },
};
</script>

<style scoped></style>
